import { createSelector } from 'reselect'
import { Firebase } from '../../Core'
import * as utils from './ranking.utils'

export const getRankingState = (state) => state.mars.ranking
export const getRankingUsers = createSelector([getRankingState], (ranking) => ranking.users)
export const getRankingFilter = createSelector([getRankingState], (ranking) => ranking.filter)
export const getRankingSearch = createSelector([getRankingState], (ranking) => ranking.search)
export const getSelectedFederation = createSelector(
  [getRankingState],
  (ranking) => ranking.federation
)
export const getFilteredRanking = createSelector(
  [
    Firebase.selectors.getPlayersRanking,
    getRankingFilter,
    Firebase.selectors.getUserData,
    getRankingSearch,
  ],
  (ranking, filter, userData, search) => {
    const newRanking = ranking
    return utils.getFilteredUsers(newRanking, filter, userData, search)
  }
)

export const getRankingInFederation = createSelector(
  [Firebase.selectors.getPlayersRanking, getSelectedFederation],
  (ranking, federation) => {
    const newRanking = ranking
    return utils.getFederationRanking(newRanking, federation)
  }
)

export const getPodium = createSelector([getFilteredRanking], (ranking) =>
  ranking.filter((user, index) => index <= 2)
)

export const getFederationPodium = createSelector(
  [Firebase.selectors.getFederationsRanking],
  (ranking) => ranking.filter((federation, index) => index <= 2)
)

export const getChatTarget = createSelector([getRankingState], (ranking) => ranking.chatTarget)
